import taskService from 'resources/task/task.service';
import templateService from 'resources/template/template.service';
import documentService from 'resources/document/document.service';
import userService from 'resources/user/user.service';
import * as companyApi from 'resources/company/company.api';
import { copyDocument } from 'resources/document/workflows/copyDocument';
import { TEMPLATE_TO_TYPES } from 'resources/template/template.constants';
import { isValidEmail } from 'utils/email';


const copyTemplateForTask = async ({ templateId, taskId, deal }) => {
  const defaultTemplateToCopy = await templateService.findById(templateId);
  if (!defaultTemplateToCopy) return null;

  const dealAgent = await userService.findById(deal.realtor_id);
  const dealClients = await userService.getUsersByIds(deal.client_ids);
  const dealCoordinator = await userService.findById(deal.coordinator_id);
  const companyAdvancedFields = await companyApi.getAdvancedFields(deal.company_id);
  const toEmails = defaultTemplateToCopy.to_emails
    ? getEmailsFromTags(defaultTemplateToCopy.to_emails, deal, dealAgent, dealClients, dealCoordinator, companyAdvancedFields)
    : [];
  const ccEmails = defaultTemplateToCopy.cc_emails
    ? getEmailsFromTags(defaultTemplateToCopy.cc_emails, deal, dealAgent, dealClients, dealCoordinator, companyAdvancedFields)
    : null;
  const bccEmails = defaultTemplateToCopy.bcc_emails
    ? getEmailsFromTags(defaultTemplateToCopy.bcc_emails, deal, dealAgent, dealClients, dealCoordinator, companyAdvancedFields)
    : null;

  const transactionEmailTemplate = await templateService.createTransactionEmailTemplate({
    title: defaultTemplateToCopy.title,
    subject: defaultTemplateToCopy.subject,
    to_emails: toEmails,
    cc_emails: ccEmails,
    bcc_emails: bccEmails,
    body: defaultTemplateToCopy.body,
    company_id: defaultTemplateToCopy.company_id,
    from_email: defaultTemplateToCopy.from_email,
  });

  const documentsToCopy = await documentService.getByTemplateId(templateId);

  await Promise.all([
    taskService.updateTask({
      id: taskId,
      template_id: transactionEmailTemplate.id,
    }),
    (documentsToCopy?.length && (
      Promise.all(documentsToCopy.map((document) => copyDocument({
        copyDocumentId: document.id,
        filePath: transactionEmailTemplate.id,
        companyId: transactionEmailTemplate.company_id,
        templateId: transactionEmailTemplate.id,
        uploaderId: document.uploader_id,
      })))
    )),
  ]);

  return transactionEmailTemplate;
};

const getEmailsFromTags = (emailTags, deal, dealAgent, dealClients, dealCoordinator, companyAdvancedFields) => {
  let emails = [];

  emailTags.forEach((emailTag) => {
    if (emailTag === TEMPLATE_TO_TYPES.AGENT) {
      emails.push(dealAgent.email);
      return;
    }

    if (emailTag === TEMPLATE_TO_TYPES.CLIENTS) {
      const clientEmails = dealClients.filter((client) => client.email).map((client) => client.email);
      emails = [...emails, ...clientEmails];
      return;
    }

    if (emailTag === TEMPLATE_TO_TYPES.COORDINATOR) {
      emails.push(dealCoordinator.email);
      return;
    }

    const companyField = companyAdvancedFields.find((field) => field.label === emailTag);
    const companyFieldName = companyField?.name;
    const dealFieldValue = deal.advanced_fields[companyFieldName];
    if (dealFieldValue && isValidEmail(dealFieldValue)) {
      emails.push(dealFieldValue);
      return;
    }

    emails.push(emailTag);
  });

  return emails;
};

export { copyTemplateForTask };
